// Malayalam
const dict = {
  // Brand / common
  "Every Win, Securely Paid.": "ഓരോ വിജയത്തിനും, സുരക്ഷിത പേയ്‌മെന്റ്.",
  "Loading Sara777": "Sara777 ലോഡ് ചെയ്യുന്നു",
  "App version {version}": "ആപ്പ് പതിപ്പ് {version}",
  "Language": "ഭാഷ",
  "Home": "ഹോം",
  "Account": "അക്കൗണ്ട്",
  "Wallet": "വാലറ്റ്",
  "History": "ചരിത്രം",
  "All Bids": "എല്ലാ ബിഡുകളും",
  "Profile": "പ്രൊഫൈൽ",
  "My Profile": "എന്റെ പ്രൊഫൈൽ",
  "Open menu": "മെനു തുറക്കുക",
  "Close menu": "മെനു അടയ്ക്കുക",
  "Go back": "തിരികെ പോകുക",
  "Back": "തിരികെ",
  "Close": "ക്ലോസ്",
  "Open": "ഓപ്പൺ",
  "Submit": "സമർപ്പിക്കുക",
  "Cancel": "റദ്ദാക്കുക",
  "Continue": "തുടരുക",
  "Update": "അപ്ഡേറ്റ് ചെയ്യുക",
  "Copy": "പകർത്തുക",
  "Change": "മാറ്റുക",
  "Refresh": "പുതുക്കുക",
  "Date": "തീയതി",
  "Status": "നില",
  "Action": "പ്രവർത്തനം",
  "Remark": "കുറിപ്പ്",
  "Amount": "തുക",
  "Points": "പോയിന്റുകൾ",
  "Bids": "ബിഡുകൾ",
  "Session": "സെഷൻ",
  "Pending": "തീർപ്പാക്കാനുണ്ട്",
  "Failed": "പരാജയപ്പെട്ടു",
  "Success": "വിജയിച്ചു",
  "optional": "ഐച്ഛികം",
  "Since {date}": "{date} മുതൽ",

  // Sidebar
  "Account Statement": "അക്കൗണ്ട് സ്റ്റേറ്റ്മെന്റ്",
  "Game Rates": "ഗെയിം നിരക്കുകൾ",
  "Terms & Conditions": "നിബന്ധനകളും വ്യവസ്ഥകളും",
  "Video": "വീഡിയോ",
  "Logout": "ലോഗ് ഔട്ട്",
  "Privacy Policy": "സ്വകാര്യതാ നയം",

  // Login / sign-up / MPIN / OTP
  "Login": "ലോഗിൻ",
  "Sign up": "സൈൻ അപ്പ് ചെയ്യുക",
  "New here?": "പുതിയ ആളാണോ?",
  "Already have an account?": "ഇതിനകം അക്കൗണ്ട് ഉണ്ടോ?",
  "Have an account?": "അക്കൗണ്ട് ഉണ്ടോ?",
  "Enter Number": "നമ്പർ നൽകുക",
  "Enter your valid mobile number": "നിങ്ങളുടെ ശരിയായ മൊബൈൽ നമ്പർ നൽകുക",
  "Mobile number": "മൊബൈൽ നമ്പർ",
  "Mobile Number": "മൊബൈൽ നമ്പർ",
  "Enter mobile number": "മൊബൈൽ നമ്പർ നൽകുക",
  "4-digit MPIN": "4 അക്ക MPIN",
  "Enter your 4-digit MPIN": "നിങ്ങളുടെ 4 അക്ക MPIN നൽകുക",
  "Show MPIN": "MPIN കാണിക്കുക",
  "Hide MPIN": "MPIN മറയ്ക്കുക",
  "Create Account": "അക്കൗണ്ട് സൃഷ്ടിക്കുക",
  "Create your new account": "നിങ്ങളുടെ പുതിയ അക്കൗണ്ട് സൃഷ്ടിക്കുക",
  "Full name": "മുഴുവൻ പേര്",
  "Email address (optional)": "ഇമെയിൽ വിലാസം (ഐച്ഛികം)",
  "Create MPIN": "MPIN സൃഷ്ടിക്കുക",
  "Set a 4-digit PIN to log in quickly": "വേഗത്തിൽ ലോഗിൻ ചെയ്യാൻ 4 അക്ക PIN സജ്ജമാക്കുക",
  "Enter MPIN": "MPIN നൽകുക",
  "Confirm MPIN": "MPIN സ്ഥിരീകരിക്കുക",
  "{label} digit {n}": "{label} അക്കം {n}",
  "Never share your MPIN with anyone.": "നിങ്ങളുടെ MPIN ആരുമായും പങ്കിടരുത്.",
  "MPINs match": "MPIN-കൾ ഒത്തുപോകുന്നു",
  "MPINs don't match. Try again.": "MPIN-കൾ ഒത്തുപോകുന്നില്ല. വീണ്ടും ശ്രമിക്കുക.",
  "Enter your MPIN to login": "ലോഗിൻ ചെയ്യാൻ നിങ്ങളുടെ MPIN നൽകുക",
  "Enter OTP": "OTP നൽകുക",
  "Verify your mobile number": "നിങ്ങളുടെ മൊബൈൽ നമ്പർ സ്ഥിരീകരിക്കുക",
  "Verify": "സ്ഥിരീകരിക്കുക",

  // Home
  "Add Money": "പണം ചേർക്കുക",
  "Withdraw": "പിൻവലിക്കുക",
  "Betting is Running Now": "ബെറ്റിംഗ് ഇപ്പോൾ നടക്കുന്നു",
  "Betting is Closed for Today": "ഇന്നത്തേക്ക് ബെറ്റിംഗ് അടച്ചു",
  "Play {name}": "{name} കളിക്കുക",
  "{name} chart": "{name} ചാർട്ട്",
  "Chart Info": "ചാർട്ട് വിവരം",
  "Contact Support": "സപ്പോർട്ടുമായി ബന്ധപ്പെടുക",
  "Jodi Chart": "ജോഡി ചാർട്ട്",
  "Pana Chart": "പാന ചാർട്ട്",
  "Past jodi results": "മുൻ ജോഡി ഫലങ്ങൾ",
  "Past panna results": "മുൻ പാന ഫലങ്ങൾ",
  "Call Now": "ഇപ്പോൾ വിളിക്കുക",
  "Talk to our support team": "ഞങ്ങളുടെ സപ്പോർട്ട് ടീമുമായി സംസാരിക്കുക",
  "WhatsApp": "വാട്ട്‌സ്ആപ്പ്",
  "Chat with us on WhatsApp": "വാട്ട്‌സ്ആപ്പിൽ ഞങ്ങളുമായി ചാറ്റ് ചെയ്യുക",

  // Game types
  "Select a game type to play": "കളിക്കാൻ ഒരു ഗെയിം തരം തിരഞ്ഞെടുക്കുക",
  "Single Digit": "സിംഗിൾ ഡിജിറ്റ്",
  "Single Digit Bulk": "സിംഗിൾ ഡിജിറ്റ് ബൾക്ക്",
  "Jodi Digit": "ജോഡി ഡിജിറ്റ്",
  "Jodi Digit Bulk": "ജോഡി ഡിജിറ്റ് ബൾക്ക്",
  "Single Pana": "സിംഗിൾ പാന",
  "Single Pana Bulk": "സിംഗിൾ പാന ബൾക്ക്",
  "Double Pana": "ഡബിൾ പാന",
  "Double Pana Bulk": "ഡബിൾ പാന ബൾക്ക്",
  "Triple Pana": "ട്രിപ്പിൾ പാന",
  "Triple Pana Bulk": "ട്രിപ്പിൾ പാന ബൾക്ക്",
  "Half Sangam": "ഹാഫ് സംഗം",
  "Full Sangam": "ഫുൾ സംഗം",
  "Jodi": "ജോഡി",
  "Single Panna": "സിംഗിൾ പാന",
  "Double Panna": "ഡബിൾ പാന",
  "Triple Panna": "ട്രിപ്പിൾ പാന",
  "Tripple Panna": "ട്രിപ്പിൾ പാന",

  // Playing
  "Enter points": "പോയിന്റുകൾ നൽകുക",
  "Enter {label}": "{label} നൽകുക",
  "Add Bid": "ബിഡ് ചേർക്കുക",
  "Submit Bid": "ബിഡ് സമർപ്പിക്കുക",
  "Pana": "പാന",
  "Digits": "അക്കങ്ങൾ",
  "Open Pana": "ഓപ്പൺ പാന",
  "Close Pana": "ക്ലോസ് പാന",
  "Open Digit": "ഓപ്പൺ ഡിജിറ്റ്",
  "Close Digit": "ക്ലോസ് ഡിജിറ്റ്",
  "No bids added yet": "ഇതുവരെ ബിഡുകൾ ചേർത്തിട്ടില്ല",
  "Remove bid {number}": "ബിഡ് {number} നീക്കം ചെയ്യുക",
  "Bid status": "ബിഡ് നില",
  "Note: Bid once played will not be cancelled": "ശ്രദ്ധിക്കുക: ഒരിക്കൽ വെച്ച ബിഡ് റദ്ദാക്കില്ല",
  "HOLD": "ഹോൾഡ്",
  "LOADING...": "ലോഡ് ചെയ്യുന്നു...",
  "Failed !!": "പരാജയപ്പെട്ടു !!",

  // Bids / history
  "Transaction ID": "ഇടപാട് ID",
  "Placed": "വെച്ചു",
  "No bid history found.": "ബിഡ് ചരിത്രം കണ്ടെത്തിയില്ല.",
  "Balance": "ബാലൻസ്",
  "No transactions yet": "ഇതുവരെ ഇടപാടുകളൊന്നുമില്ല",
  "Deposit": "നിക്ഷേപം",
  "No history found.": "ചരിത്രം കണ്ടെത്തിയില്ല.",
  "In Process": "പ്രക്രിയയിലാണ്",
  "Declined": "നിരസിച്ചു",
  "User Withdrawal / deposit History": "പിൻവലിക്കൽ / നിക്ഷേപ ചരിത്രം",

  // Charts
  "Bottom": "താഴേക്ക്",
  "Back to top": "മുകളിലേക്ക് പോകുക",
  "Mon": "തിങ്കൾ",
  "Tue": "ചൊവ്വ",
  "Wed": "ബുധൻ",
  "Thu": "വ്യാഴം",
  "Fri": "വെള്ളി",
  "Sat": "ശനി",
  "Sun": "ഞായർ",

  // Rates / how to play
  "Main game win ratio for all bids": "എല്ലാ ബിഡുകൾക്കുമുള്ള പ്രധാന ഗെയിം വിജയ അനുപാതം",
  "{min} KA {max}": "{min} ന് {max}",
  "How To Play": "എങ്ങനെ കളിക്കാം",
  "Download our application from Google Play Store or from our official website.": "ഞങ്ങളുടെ ആപ്പ് Google Play Store-ൽ നിന്നോ ഞങ്ങളുടെ ഔദ്യോഗിക വെബ്സൈറ്റിൽ നിന്നോ ഡൗൺലോഡ് ചെയ്യുക.",
  "Register with your Mobile Number, Email ID, and User Name on our platform.": "നിങ്ങളുടെ മൊബൈൽ നമ്പർ, ഇമെയിൽ ID, യൂസർ നെയിം എന്നിവ ഉപയോഗിച്ച് ഞങ്ങളുടെ പ്ലാറ്റ്ഫോമിൽ രജിസ്റ്റർ ചെയ്യുക.",
  "Login to the application using your Mobile Number and MPIN.": "നിങ്ങളുടെ മൊബൈൽ നമ്പറും MPIN-ഉം ഉപയോഗിച്ച് ആപ്പിൽ ലോഗിൻ ചെയ്യുക.",
  "Select the Game type, choose your favourite number, and start to play the game.": "ഗെയിം തരം തിരഞ്ഞെടുത്ത്, നിങ്ങളുടെ ഇഷ്ട നമ്പർ തിരഞ്ഞെടുത്ത് കളിക്കാൻ തുടങ്ങുക.",
  "Get a chance to win up to 10 Lac Points.": "10 ലക്ഷം പോയിന്റുകൾ വരെ നേടാനുള്ള അവസരം നേടുക.",

  // Wallet
  "Add Fund": "ഫണ്ട് ചേർക്കുക",
  "Instant deposit via UPI / QR Code": "UPI / QR കോഡ് വഴി തൽക്ഷണ നിക്ഷേപം",
  "Manual Deposit": "മാനുവൽ നിക്ഷേപം",
  "Upload your payment screenshot": "നിങ്ങളുടെ പേയ്‌മെന്റ് സ്ക്രീൻഷോട്ട് അപ്‌ലോഡ് ചെയ്യുക",
  "Withdraw Fund": "ഫണ്ട് പിൻവലിക്കുക",
  "Fast and secure withdrawal to bank": "ബാങ്കിലേക്ക് വേഗമേറിയതും സുരക്ഷിതവുമായ പിൻവലിക്കൽ",
  "Deposit & Withdraw History": "നിക്ഷേപ & പിൻവലിക്കൽ ചരിത്രം",
  "Check your past transactions statement": "നിങ്ങളുടെ മുൻ ഇടപാടുകളുടെ സ്റ്റേറ്റ്മെന്റ് കാണുക",
  "Add Bank Details": "ബാങ്ക് വിവരങ്ങൾ ചേർക്കുക",
  "Update bank account for instant payouts": "തൽക്ഷണ പേയൗട്ടിനായി ബാങ്ക് അക്കൗണ്ട് അപ്ഡേറ്റ് ചെയ്യുക",
  "Total Wallet Balance": "മൊത്തം വാലറ്റ് ബാലൻസ്",
  "Pay": "പണമടയ്ക്കുക",
  "Minimum deposit limit is {amount}.": "കുറഞ്ഞ നിക്ഷേപ പരിധി {amount} ആണ്.",
  "Enter withdraw points": "പിൻവലിക്കേണ്ട പോയിന്റുകൾ നൽകുക",
  "Amount is sent to your saved bank account.": "തുക നിങ്ങൾ സേവ് ചെയ്ത ബാങ്ക് അക്കൗണ്ടിലേക്ക് അയയ്ക്കും.",
  "Update bank details": "ബാങ്ക് വിവരങ്ങൾ അപ്ഡേറ്റ് ചെയ്യുക",
  "Pay to the UPI ID below, then enter the UTR number and upload the payment screenshot.": "താഴെയുള്ള UPI ID-യിലേക്ക് പണമടച്ച്, UTR നമ്പർ നൽകി, പേയ്‌മെന്റ് സ്ക്രീൻഷോട്ട് അപ്‌ലോഡ് ചെയ്യുക.",
  "Enter amount": "തുക നൽകുക",
  "Pay to UPI ID": "ഈ UPI ID-യിലേക്ക് പണമടയ്ക്കുക",
  "UTR Number": "UTR നമ്പർ",
  "Enter 12-digit UTR number": "12 അക്ക UTR നമ്പർ നൽകുക",
  "Payment Screenshot": "പേയ്‌മെന്റ് സ്ക്രീൻഷോട്ട്",
  "Tap to upload screenshot": "സ്ക്രീൻഷോട്ട് അപ്‌ലോഡ് ചെയ്യാൻ ടാപ്പ് ചെയ്യുക",
  "Tap to change": "മാറ്റാൻ ടാപ്പ് ചെയ്യുക",
  "PNG or JPG": "PNG അല്ലെങ്കിൽ JPG",
  "Bank Details": "ബാങ്ക് വിവരങ്ങൾ",
  "IFSC Code": "IFSC കോഡ്",
  "Account number": "അക്കൗണ്ട് നമ്പർ",
  "Bank name": "ബാങ്കിന്റെ പേര്",
  "Account holder name": "അക്കൗണ്ട് ഉടമയുടെ പേര്",
  "Google Pay number": "Google Pay നമ്പർ",
  "PhonePe number": "PhonePe നമ്പർ",
  "Paytm number": "Paytm നമ്പർ",

  // Profile
  "Edit profile": "പ്രൊഫൈൽ എഡിറ്റ് ചെയ്യുക",
  "Joined since": "ചേർന്ന തീയതി",
  "Phone": "ഫോൺ",
  "Wallet Balance": "വാലറ്റ് ബാലൻസ്",
  "Update User Information": "ഉപയോക്തൃ വിവരങ്ങൾ അപ്ഡേറ്റ് ചെയ്യുക",
  "Name": "പേര്",
  "Email": "ഇമെയിൽ",
  "PhonePe": "PhonePe",
  "Google Pay": "Google Pay",
  "Paytm": "Paytm",
  "Name is required.": "പേര് ആവശ്യമാണ്.",
  "Email is required.": "ഇമെയിൽ ആവശ്യമാണ്.",
  "Email is invalid.": "ഇമെയിൽ അസാധുവാണ്.",
  "PhonePe number must be 10 digits.": "PhonePe നമ്പർ 10 അക്കങ്ങൾ ആയിരിക്കണം.",
  "Paytm number must be 10 digits.": "Paytm നമ്പർ 10 അക്കങ്ങൾ ആയിരിക്കണം.",
  "Google Pay number must be 10 digits.": "Google Pay നമ്പർ 10 അക്കങ്ങൾ ആയിരിക്കണം.",

  // Pop-up messages
  "Enter User name !!": "യൂസർ നെയിം നൽകുക !!",
  "Enter Valid mobile number !!": "ശരിയായ മൊബൈൽ നമ്പർ നൽകുക !!",
  "Enter Valid email address !!": "ശരിയായ ഇമെയിൽ വിലാസം നൽകുക !!",
  "Enter your 4-digit MPIN !!": "നിങ്ങളുടെ 4 അക്ക MPIN നൽകുക !!",
  "Only 4 digit allow !!": "4 അക്കങ്ങൾ മാത്രം അനുവദനീയം !!",
  "Mpin does not match with confirm Mpin.": "MPIN-ഉം സ്ഥിരീകരണ MPIN-ഉം ഒത്തുപോകുന്നില്ല.",
  "This number is already registered. Please login.": "ഈ നമ്പർ ഇതിനകം രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്. ദയവായി ലോഗിൻ ചെയ്യുക.",
  "This number is not registered. Please create your account.": "ഈ നമ്പർ രജിസ്റ്റർ ചെയ്തിട്ടില്ല. ദയവായി നിങ്ങളുടെ അക്കൗണ്ട് സൃഷ്ടിക്കുക.",
  "Unable to sign in. Please try again.": "ലോഗിൻ ചെയ്യാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  "Unable to continue. Please try again.": "തുടരാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  "Unable to create account. Please try again.": "അക്കൗണ്ട് സൃഷ്ടിക്കാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  "Api Error": "സെർവർ പിശക്",
  "Something went wrong. Please try again.": "എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
  "This Market Betting Is Closed For Today.": "ഈ മാർക്കറ്റിൽ ഇന്നത്തേക്ക് ബെറ്റിംഗ് അടച്ചു.",
  "Please Enter minimum 10 Points.": "ദയവായി കുറഞ്ഞത് 10 പോയിന്റുകൾ നൽകുക.",
  "Please Enter Points for Betting.": "ദയവായി ബെറ്റിംഗിനായി പോയിന്റുകൾ നൽകുക.",
  "Please Select Bids for Betting.": "ദയവായി ബെറ്റിംഗിനായി ബിഡുകൾ തിരഞ്ഞെടുക്കുക.",
  "Please enter a valid Number.": "ദയവായി ശരിയായ നമ്പർ നൽകുക.",
  "Please Enter Amount first.": "ദയവായി ആദ്യം തുക നൽകുക.",
  "Please Enter UTR first.": "ദയവായി ആദ്യം UTR നൽകുക.",
  "Please select a valid image file.": "ദയവായി ശരിയായ ചിത്ര ഫയൽ തിരഞ്ഞെടുക്കുക.",
  "UPI copied to clipboard!": "UPI ക്ലിപ്പ്ബോർഡിലേക്ക് പകർത്തി!",
  "Profile Updated Successfully.": "പ്രൊഫൈൽ വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു.",
};

export default dict;
